import APICall from './../utils/APICall';
import Constants from '../utils/Constants';
import fire from '../utils/Toastr';

async function formDataAPICall(url, method, data) {
    const authToken = sessionStorage.getItem("token");
    const tenant = sessionStorage.getItem("tenantId");
    try {
        const response = await fetch(Constants.apiBaseUrl + url.trim(), {
            method: method,
            body: data,
            headers: {
                'Authorization': `Bearer ${authToken}`,
                'tenant': tenant,
            },
        });
        const responseData = await response.json();
        if (response.status === 401) {
            sessionStorage.clear();
            window.location.href = "/";
            return null;
        }
        if (!response.ok) {
            fire("warning", responseData?.message || "Request failed");
            return null;
        }
        return responseData;
    } catch (error) {
        fire("error", "Network error. Please check your connection.");
        return null;
    }
}

export default class WakanowServices {

    static createHolidayPackage = async (data) => {
        return await formDataAPICall(`/api/Wakanow/holiday-package/create`, "POST", data)
    }

    static updateHolidayPackage = async (data) => {
        return await formDataAPICall(`/api/Wakanow/holiday-package/update`, "PUT", data)
    }

    static listHolidayPackages = async (pageIndex, pageSize, search, startDate, endDate) => {
        let queryString = `/api/Wakanow/holiday-packages?`;
        if (pageIndex) queryString += `page=${pageIndex}`
        if (pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${encodeURIComponent(search)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static getHolidayPackageById = async (id) => {
        return await APICall(`/api/Wakanow/holiday-package/${id}`, "GET")
    }

    static deactivateHolidayPackage = async (id) => {
        return await APICall(`/api/Wakanow/holiday-package/${id}/deactivate`, "PATCH")
    }

    static exportHolidayPackages = async (search, startDate, endDate) => {
        let queryString = `/api/Wakanow/holiday-packages/export?`;
        if (search) queryString += `search=${encodeURIComponent(search)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static listHolidayPackageRequests = async (pageIndex, pageSize, search, startDate, endDate) => {
        let queryString = `/api/Wakanow/holiday-package-requests?`;
        if (pageIndex) queryString += `page=${pageIndex}`
        if (pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${encodeURIComponent(search)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static getHolidayPackageRequestById = async (id) => {
        return await APICall(`/api/Wakanow/holiday-package-requests/${id}`, "GET")
    }

    static exportHolidayPackageRequests = async (search, startDate, endDate) => {
        let queryString = `/api/Wakanow/holiday-package-requests/export?`;
        if (search) queryString += `search=${encodeURIComponent(search)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static listFlightBookings = async (pageIndex, pageSize, search, bookingStatus, startDate, endDate) => {
        let queryString = `/api/Wakanow/flight-bookings?`;
        if (pageIndex) queryString += `page=${pageIndex}`;
        if (pageSize) queryString += `&pageLimit=${pageSize}`;
        if (search) queryString += `&search=${encodeURIComponent(search)}`;
        if (bookingStatus) queryString += `&bookingStatus=${encodeURIComponent(bookingStatus)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static getFlightBookingById = async (id) => {
        return await APICall(`/api/Wakanow/flight-booking/${id}`, "GET")
    }

    static exportFlightBookings = async (search, bookingStatus, startDate, endDate) => {
        let queryString = `/api/Wakanow/flight-bookings/export?`;
        if (search) queryString += `search=${encodeURIComponent(search)}`;
        if (bookingStatus) queryString += `&bookingStatus=${encodeURIComponent(bookingStatus)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static getWalletBalance = async () => {
        return await APICall(`/api/Wakanow/wallet-balance`, "GET")
    }

    static listHotelBookings = async (pageIndex, pageSize, search, bookingStatus, startDate, endDate) => {
        let queryString = `/api/Wakanow/hotel-bookings?`;
        if (pageIndex) queryString += `page=${pageIndex}`;
        if (pageSize) queryString += `&pageLimit=${pageSize}`;
        if (search) queryString += `&search=${encodeURIComponent(search)}`;
        if (bookingStatus) queryString += `&bookingStatus=${encodeURIComponent(bookingStatus)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }

    static getHotelBookingById = async (id) => {
        return await APICall(`/api/Wakanow/hotel-booking/${id}`, "GET")
    }

    static exportHotelBookings = async (search, bookingStatus, startDate, endDate) => {
        let queryString = `/api/Wakanow/hotel-bookings/export?`;
        if (search) queryString += `search=${encodeURIComponent(search)}`;
        if (bookingStatus) queryString += `&bookingStatus=${encodeURIComponent(bookingStatus)}`;
        if (startDate) queryString += `&startDate=${encodeURIComponent(startDate)}`;
        if (endDate) queryString += `&endDate=${encodeURIComponent(endDate)}`;
        return await APICall(queryString, "GET")
    }
}
